import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrSafariToolbarSpace from 'client/components/SrSafariToolbarSpace';

import './SrSimpleMessageModal.less';

export const SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP = 'SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP';
const SR_SIMPLE_MESSAGE_MODAL_THEME_TO_CLASSNAME_MAPPING = {
  [SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP]: 'srSimpleMessageModalThemeSlideUp',
};
const SR_SIMPLE_MESSAGE_MODAL_THEMES = Object.keys(SR_SIMPLE_MESSAGE_MODAL_THEME_TO_CLASSNAME_MAPPING);

const SrSimpleMessageModal = ({
  className,
  contentContainerClassName,
  iconUrl,
  headline,
  underline,
  message,
  buttonText,
  buttonTheme,
  buttonHref,
  subLabelText,
  sublabelClassName,
  showSubLabelDecoration,
  onSubLabelClick,
  onButtonClick,
  onClose,
  maxWidth,
  minWidth,
  maxIconWidth,
  maxIconHeight,
  multiButtons,
  customCtas,
  theme,
  innerStyle,
  useSafariToolbarSpace,
}) => (
  <SrDarkModal
    className={classnames('SrSimpleMessageModal', className)}
    onClose={onClose || (() => true)}
  >
    <span styleName={classnames(
      'modalContentContainer',
      theme ? SR_SIMPLE_MESSAGE_MODAL_THEME_TO_CLASSNAME_MAPPING[theme] : null,
    )}
    >
      <SrModalContent
        style={{
          maxWidth: maxWidth ? `${maxWidth}px` : undefined,
          minWidth: minWidth ? `${minWidth}px` : undefined,
        }}
        innerStyle={innerStyle}
      >
        {onClose && (
          <div styleName='closeModalIcon' onClick={onClose} />
        )}
        <div styleName={classnames('contentContainer', contentContainerClassName, { noIcon: !iconUrl })}>
          {iconUrl && (
            <div
              style={{
                maxWidth: maxIconWidth ? `${maxIconWidth}px` : undefined,
                maxHeight: maxIconHeight ? `${maxIconHeight}px` : undefined,
              }}
              styleName='heroIcon'
            >
              <img
                styleName='heroIconImage'
                style={maxIconHeight ? {
                  height: `${maxIconHeight}px`,
                  maxHeight: `${maxIconHeight}px`,
                } : undefined}
                src={iconUrl}
                alt=''
              />
            </div>
          )}
          <div styleName='modalHeadline'>
            {headline}
          </div>
          {underline &&
            <img
              styleName='headerUnderline'
              alt='header underline'
              src='/images/yellow-underline.svg'
            />}
          <div styleName='modalMessage'>
            {message}
          </div>
          <div
            styleName={classnames('modalFooter', !message ? 'noMessage' : null)}
          >
            {multiButtons && multiButtons.map((button, index) => (
              <SrBox
                key={index} // eslint-disable-line react/no-array-index-key
                marginTop={index === 0 ? '0px' : '18px'}
              >
                <ButtonDeprecated
                  type='button'
                  theme={button.buttonTheme}
                  onClick={button.onButtonClick || button.onClose}
                  disabled={button.buttonDisabled}
                >
                  {button.buttonText}
                </ButtonDeprecated>
              </SrBox>
            ))}
            {buttonText &&
              <ButtonDeprecated
                type='button'
                theme={buttonTheme}
                onClick={onButtonClick || onClose}
                href={buttonHref}
              >
                {buttonText}
              </ButtonDeprecated>}
            {subLabelText && (
              <div styleName={classnames('subLabelText', sublabelClassName)}>
                <SrText
                  decoration={showSubLabelDecoration ? 'underline-yellow' : undefined}
                  onClick={onSubLabelClick}
                  className={onSubLabelClick ? 'cursor-pointer' : undefined}
                >
                  {subLabelText}
                </SrText>
              </div>
            )}
            {(customCtas || []).map((node) => node)}
          </div>
        </div>
        {useSafariToolbarSpace && (
          <SrSafariToolbarSpace />
        )}
      </SrModalContent>
    </span>
  </SrDarkModal>
);

SrSimpleMessageModal.propTypes = {
  className: PropTypes.string,
  contentContainerClassName: PropTypes.string,
  iconUrl: PropTypes.string,
  headline: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  underline: PropTypes.bool,
  message:  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  buttonText: PropTypes.string,
  buttonTheme: PropTypes.string,
  buttonHref: PropTypes.string,
  subLabelText: PropTypes.string,
  onButtonClick: PropTypes.func,
  sublabelClassName: PropTypes.string,
  showSubLabelDecoration: PropTypes.bool,
  onSubLabelClick: PropTypes.func,
  onClose: PropTypes.func,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxIconWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  multiButtons: PropTypes.array,
  theme: PropTypes.oneOf(SR_SIMPLE_MESSAGE_MODAL_THEMES),
  innerStyle: PropTypes.object,
  useSafariToolbarSpace: PropTypes.bool,
};

SrSimpleMessageModal.defaultProps = {
  showSubLabelDecoration: true,
};

SrSimpleMessageModal.displayName = 'SrSimpleMessageModal';

export default SrSimpleMessageModal;
